import { request } from ".."
import { HelperCore } from "../helper";

const uploadByApi = (file) => {
  const params = HelperCore.getForm({
    up_file : file,
  });

  return request.post("/s3/upload", params, {
    dataIsForm : true,
  })
  .then(res => {
    return {
      data : {
        url : res.data.up_url,
      },
    }
  });
}

export default uploadByApi;